import TextL from './TextL';

export default TextL;
